<div class="patching-history-shell">
  <div class="patching-history-card">
    <div class="history-toolbar">
      <div class="history-toolbar-main">
        <button
          type="button"
          class="btn btn-light history-close-btn"
          (click)="close()"
        >
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          Back
        </button>
        <div>
          <h5 class="mb-1">All Patching Info</h5>
          <p class="mb-0">Saved patching info for account <span class="mono">{{ accountId }}</span>.</p>
        </div>
      </div>
    </div>

    <div class="history-summary-row">
      <div class="history-summary-left">
        <div class="history-stat-card">
          <div class="history-stat-label">Saved Records</div>
          <div class="history-stat-value">{{ count }}</div>
        </div>
        <div class="update-option-card">
          <div class="history-stat-label">Update Option</div>
          <div class="update-option-text">
            Use the <span class="mono">Edit</span> action against any record.
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-light refresh-btn" (click)="loadHistory()">Refresh</button>
    </div>

    <app-patching-history-edit
      *ngIf="editingItem"
      [accountId]="accountId"
      [environmentOptions]="environmentOptions"
      [item]="editingItem"
      (cancel)="cancelEdit()"
      (updated)="handleUpdated($event)"
    ></app-patching-history-edit>

    <div class="history-table-card">
      <div class="overflow-auto">
        <table class="table table-docs table-hover align-middle history-table">
          <thead>
            <tr>
              <th class="sn-col">S.N.</th>
              <th class="env-col">Environment</th>
              <th class="host-col">Host Name</th>
              <th class="instance-col">Instance ID</th>
              <th class="patch-col">Next Patching</th>
              <th class="email-col">To Email</th>
              <th class="email-col">CC Email</th>
              <th></th>
            </tr>
          </thead>

          <tbody *ngIf="items.length > 0 && !loading">
            <tr *ngFor="let item of items; let i = index">
              <td class="sn-col">{{ i + 1 }}</td>
              <td class="env-col">{{ item.environment || "-" }}</td>
              <td class="host-col">{{ item.hostname || item.instance_name || "-" }}</td>
              <td class="instance-col">{{ item.instance_id || "-" }}</td>
              <td class="patch-col">{{ item.next_patching_date_time || "-" }}</td>
              <td class="email-col">{{ formatEmailsForDisplay(item.to_email_communication) }}</td>
              <td class="email-col">{{ formatEmailsForDisplay(item.cc_email_communication) }}</td>
              <td class="edit-icon-cell">
                <span class="edit-icon-btn" (click)="startEdit(item)" title="Edit">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </span>
              </td>
            </tr>
          </tbody>

          <tbody *ngIf="loading">
            <tr>
              <td colspan="8" class="center">Loading saved patching information...</td>
            </tr>
          </tbody>

          <tbody *ngIf="!loading && !items.length && !errorMessage">
            <tr>
              <td colspan="8" class="center">No saved patching information found.</td>
            </tr>
          </tbody>

          <tbody *ngIf="!loading && errorMessage">
            <tr>
              <td colspan="8" class="center">{{ errorMessage }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
